import React from "react";

interface PrintComponentProps {
  content: string;
  styles?: string;
  printDisplay?: string;
}

const PrintComponent: React.FC<PrintComponentProps> = ({
  content,
  styles = "",
  printDisplay = "Print",
}) => {
  const handlePrint = () => {
    const printWindow: Window | null = window.open(
      "",
      "",
      "width=800,height=600"
    );

    if (!printWindow) {
      alert("Popup blocked! Please allow popups and try again.");
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            @page {
              margin: 1cm;
            }

            body {
              font-family: Arial, sans-serif;
              padding: 0;
              margin: 0;
            }

            h1, h2, h3, p {
              page-break-inside: avoid;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            thead {
              display: table-header-group;
              border-top: 10px solid white;
            }

            tfoot {
              display: table-footer-group;
            }

            tr {
              page-break-inside: avoid;
            }

            td, th {
              border: 1px solid #ccc;
              padding: 4px;
            }
            tfoot {
              display: table-footer-group;
            }

            ${styles}
          </style>
        </head>
        <body>
          ${content}
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                window.close();
              }, 500);
            }
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  return <button onClick={handlePrint}>{printDisplay}</button>;
};

export default PrintComponent;
